import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginService } from './services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  public API_URL = 'https://services.autoscoop.com.au/api';

  constructor(public httpClient: HttpClient, public loginService: LoginService) {}
  public viewAllRides(): Observable<any> {
    return this.httpClient.get<any>(`${this.API_URL}/userAllRide`);
  }

  public socialLogin(data: any): Observable<any> {
    return this.httpClient.post(`${this.API_URL}/user/login/social`, data);
  }

  public getRideByRideID(rideId: any): Observable<any> {
    return this.httpClient.get(`${this.API_URL}/rideId/${rideId}`);
  }
  public createRide(data: any): Observable<any> {
    return this.httpClient.post(`${this.API_URL}/eBid/ride`, data);
  }

  public createLift(data: any): Observable<any> {
    const userId = this.loginService.getuser_id();
    return this.httpClient.post(`${this.API_URL}/create/lift/${userId}`, data);
  }

  public getVehicleTripsByUser(): Observable<any> {
    const userId = this.loginService.getuser_id();
    return this.httpClient.get(this.API_URL + '/userRideByUserId/' + userId);
  }

  public getRequestByUserId(): Observable<any> {
    const userId = this.loginService.getuser_id();
    return this.httpClient.get(this.API_URL + '/requestByUserId/' + userId);
  }

  public getRequestsByRideId(rideId: any): Observable<any> {
    return this.httpClient.get(this.API_URL + '/requestByRideId/' + rideId);
  }
  public approveTripRequest(data: any): Observable<any> {
    return this.httpClient.post(this.API_URL + '/updateRequest/', data);
  }

  // Profile

  public getUserDetails(): Observable<any> {
    const userId = this.loginService.getuser_id();
    return this.httpClient.get(`${this.API_URL}/user/${userId}`);
  }

  public editProfile(data: any): Observable<any> {
    data.userId = this.loginService.getuser_id();
    return this.httpClient.post(`${this.API_URL}/updatePhoto?_method=PUT`, data);
  }

  // Chat

  public getuserChatByRequestId(id: any): Observable<any> {
    return this.httpClient.get(`${this.API_URL}/userChatByRideRequestId/${id}`);
  }

  public addUserRequestChat(data: any): Observable<any> {
    return this.httpClient.post(`${this.API_URL}/userRequestChatAdd`, data);
  }
}
